import { useCallback, useState } from "react";

// Generation/history values are commands for the current editor, not a second
// source of truth. A Chat refresh must invalidate them before the keyed editor
// mounts: clearing in an effect is too late for the child's mount effects.
export function useDraftSceneOverride(documentId, refreshNonce) {
  const [override, setOverride] = useState({ documentId, refreshNonce, value: "" });
  const isCurrent = override.documentId === documentId && override.refreshNonce === refreshNonce;
  if (!isCurrent) {
    setOverride({ documentId, refreshNonce, value: "" });
  }
  const setValue = useCallback((value) => {
    setOverride(current => {
      // A generation started before the refresh can still deliver late chunks.
      if (current.documentId !== documentId || current.refreshNonce !== refreshNonce) return current;
      return { ...current, value };
    });
  }, [documentId, refreshNonce]);
  return [isCurrent ? override.value : "", setValue];
}
